import { useState } from "react";
import { getobj } from "../apicall/apicall";
import { timeStamp } from "../apicall/commonFunction";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Pagination from "@mui/material/Pagination";


import { StyledTableCell, StyledTableRow } from "../style/style";

export default function HubHistoryTrail(props) {
  const [activity, setactivity] = useState();
  const [infra, setinfra] = useState({
    page: 1,
    pagetotal: 1,
    loaded: true,
  });

  //Get the activity history of the device
  useState(() => {
    const url =
      process.env.REACT_APP_ZEWA_URL + "hub/history/" + props.hub_id['id'] + "/?page=1";
    const res = getobj(url);
    res.then(function (res) {
      if (res.count % 5 > 0) {
        setinfra({
          ...infra,
          pagetotal: Math.floor(res.count / 5) + 1,
        });
      } else {
        setinfra({
          ...infra,
          pagetotal: Math.floor(res.count / 5),
        });
      }

      setactivity(res.results);
      setinfra({
        ...infra,
        loaded: false,
      });
    });
  }, [props.hub_id]);

  //Page Change Function
  const handlePagechange=(event,value)=>{
      setinfra({
          ...infra,
          loaded:true,
          page:value
      })
      const url= process.env.REACT_APP_ZEWA_URL+"hub/history/"+props.hub_id['id']+"/?page="+value
      const res=getobj(url)
      res.then(function(res){
          setactivity(res.results)
          setinfra({
              ...infra,
              loaded:false
          })
      })

  }

  return (
    <div style={{margin:"10px",padding:"px"}}>
      {infra.loaded ? (
        <img src="https://zewa-logo-bucket.s3.amazonaws.com/logo/Spinner-1s-200px.gif" alt="loading..."/>
      ) : (
        <div>
        
          {activity.length > 0 ? (
            <TableContainer>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell>
                      <b>Time</b>
                    </StyledTableCell>
                    <StyledTableCell>
                      <b>User</b>
                    </StyledTableCell>
                    <StyledTableCell>
                      <b>Role</b>
                    </StyledTableCell>
                    <StyledTableCell>
                      <b>Activity</b>
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {activity.map((i) => {
                    return (
                      <StyledTableRow>
                        <StyledTableCell>
                          {timeStamp(parseInt(i.time))}
                        </StyledTableCell>
                        <StyledTableCell>
                          {i.user_id["first_name"]+" " + i.user_id["last_name"]}
                        </StyledTableCell>
                        <StyledTableCell>{i.user_id["role"]}</StyledTableCell>
                        <StyledTableCell>{i.action}</StyledTableCell>
                      </StyledTableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            "No Activity Yet"
          )}
        </div>
      )}
       <Pagination
            count={infra.pagetotal}
            page={infra.page}
            variant="outlined"
            color="primary"
            onChange={handlePagechange}
          />
    </div>
  );
}




//HubHistoryTrail